import {useEffect,useState} from "react";
import {useParams} from 'react-router-dom';
import {useApplication} from '../../core/components/ApplicationContext.js';
import {getPageTabComponent} from '../../custom/entities/EntitiyComponent.js';
import {getStringLang} from '../../core/utilities/Strings.js'
import {getCookie} from '../../core/utilities/Utilities.js';
const language=getCookie('preferredLanguage')||'en';

const PrivateRoute=(props)=>{
    const [open,setOpen]=useState(false);
    const [authenticationError,setAuthenticationError]=useState(!props.authClient.authenticated); 
    const {globalData,updateGlobalData}=useApplication();
    const {context}=useParams();
    const application={globalData,updateGlobalData,getLocale:(key,options)=>globalData?.getLocale(key,options)};

    useEffect(()=>{
        if(props.authClient.authenticated){
            setAuthenticationError(false);
        }
        else{
            setAuthenticationError(true);
            setOpen(true);
            let int=setInterval(()=>{
                setOpen(false);
                clearInterval(int);
            },2000);
            return()=>{clearInterval(int);};
        }
    },[props.authClient.authenticated,context]);

    const notAuthorized=()=>{
        return open?<div></div>:<div>{getStringLang('InvalidPageOrAccessNotAllowed',language)}</div>;
    }

    const notAuthenticated=()=>{
        return open?<div></div>:<div>{getStringLang('UserNotAuthenticated',language)}</div>;
    }

    const renderComponent=()=>{
        const entityDetail=props?.entityDetail;
        if(authenticationError){
            return notAuthenticated();
        }
        if(entityDetail===undefined){
            return notAuthorized();
        }
        if(!('route' in entityDetail)){
            return notAuthorized();
        }
        const hasPageTabs='pageTabs' in entityDetail.route;
        const hasRequiredTab=entityDetail.route.pageTabs?.some(tab=>tab.name===context);
        if(hasPageTabs&&!hasRequiredTab){
            return notAuthorized();
        }
        if('pageTabs' in entityDetail.route){
            entityDetail.route.pageTabs.forEach(tab=>{
                tab.component=getPageTabComponent(entityDetail.name,tab.name);
            });
        }
        return <props.childComponent entityDetail={props.entityDetail.route} userData={props.userData} roleConfig={props.roleConfig} application={application}/>
    }
    

    return <>
        {globalData!==null&&(renderComponent())}
    </>
};

export default PrivateRoute;